/** Faixas alinhadas a `scoreBucket` no enrichment-core e ao gráfico do dashboard. */
export type ScoreTone = 'success' | 'low' | 'medium' | 'high' | 'critical';

export const SCORE_BUCKETS = ['0-24', '25-49', '50-74', '75-89', '90-100'] as const;
export type ScoreBucket = (typeof SCORE_BUCKETS)[number];

export function scoreBucket(score: number): ScoreBucket {
  if (score >= 90) return '90-100';
  if (score >= 75) return '75-89';
  if (score >= 50) return '50-74';
  if (score >= 25) return '25-49';
  return '0-24';
}

export function scoreTone(score: number): ScoreTone {
  if (score >= 90) return 'success';
  if (score >= 75) return 'low';
  if (score >= 50) return 'medium';
  if (score >= 25) return 'high';
  return 'critical';
}

/** Cor sólida para gráficos (Recharts Cell fill). */
export const SCORE_BUCKET_COLORS: Record<ScoreBucket, string> = {
  '0-24': 'var(--color-severity-critical)',
  '25-49': 'var(--color-severity-high)',
  '50-74': 'var(--color-severity-medium)',
  '75-89': 'var(--color-severity-low)',
  '90-100': 'var(--color-success)',
};

/** Classe de texto para valores grandes (Stat) coloridos por faixa de score. */
export const SCORE_TONE_VALUE_CLASS: Record<ScoreTone, string> = {
  success: 'text-[var(--color-success)]',
  low: 'text-[var(--color-severity-low)]',
  medium: 'text-[var(--color-severity-medium)]',
  high: 'text-[var(--color-severity-high)]',
  critical: 'text-[var(--color-severity-critical)]',
};
